import { Plugin } from '@ckeditor/ckeditor5-core';
import { ButtonView } from '@ckeditor/ckeditor5-ui';
import { env } from '@ckeditor/ckeditor5-utils';
import icon from './internal-link.svg';
export default class InternalLinkUI extends Plugin {
    init() {
        const editor = this.editor;
        editor.ui.componentFactory.add('internalLink', (locale) => {
            const command = editor.commands.get('insertInternalLink');
            const buttonView = new ButtonView(locale);
            buttonView.set({
                label: `Internal link (${env.isMac ? '⌘' : '^'}⇧K)`,
                icon: icon,
                tooltip: true,
            });
            buttonView.bind('isOn').to(command, 'value');
            this.listenTo(buttonView, 'execute', () => editor.execute('insertInternalLink'));
            return buttonView;
        });
    }
}
